import {DrawerProps} from '@mantine/core';
import {FormDrawer} from './FormDrawer.tsx';
import {
    ActionStatus,
    TestingAction,
} from '../types.ts';
import {useTestingAction} from '../hooks/useTestingAction.ts';

export const AddFormDrawer = (props: DrawerProps) => {

    const {createRecord} = useTestingAction();

    const seededRecord = {status: ActionStatus.DRAFT} as TestingAction;

    return (
        <FormDrawer
            record={seededRecord}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
